import { defineMessages } from 'react-intl';

import * as Actions from './labels.actions';

const messages = defineMessages({
  tryAgain: {
    description: 'labelsReducer.tryAgain',
    defaultMessage: 'Cannot void label at this time, please try again later.',
    id: 'jlqyuk',
  },
  requestSubmitted: {
    description: 'labelsReducer.requestSubmitted',
    defaultMessage: 'Request for refund submitted.',
    id: 'UNHT99',
  },
});

const trimSuccessMessage = (message) => {
  // this message comes back from the server so we are trimming the superfluous voided message
  const SuccessMessage = 'Request for refund submitted.  This label has been voided.';
  if (message === SuccessMessage) {
    return messages.requestSubmitted;
  }
  return message;
};

const initialState = {
  fulfillments: [],
  loading: false,
  successfullyVoided: [],
  voidWarnings: [],
};

const actionTypeToReducerMap = {
  [Actions.LAUNCH_VOID_MODAL]: (state, action) => {
    const { fulfillments, isLoading } = action;
    return {
      ...state,
      fulfillments,
      loading: isLoading || false,
    };
  },
  [Actions.ON_VOID_MODAL_CLOSED]: () => initialState,
  [Actions.ACCEPT_WARNING_AND_VOID]: (state) => ({
    ...state,
    acceptedWarning: true,
  }),
  [Actions.VOID_LABELS]: (state) => ({ ...state, loading: true }),
  [Actions.VOID_LABELS_SUCCESS]: (state, action) => {
    const { updatedFulfillments } = action;
    const { successfullyVoided, fulfillments } = state;
    const updatedFulfillmentsFlat = updatedFulfillments.flat();
    const newSuccessfullyVoided = updatedFulfillmentsFlat
      .filter((datum) => datum.success)
      .map((successfulVoid) => {
        const matchingFulfillment = fulfillments.find((fulfillment) => fulfillment.fulfillmentId === successfulVoid.fulfillmentId);
        const trimmedMessage = trimSuccessMessage(successfulVoid.message);
        return {
          fulfillment: matchingFulfillment,
          voided: true,
          message: {
            isWarning: false,
            message: trimmedMessage,
          },
        };
      });
    const newVoidWarnings = updatedFulfillmentsFlat
      .filter((datum) => !datum.success)
      .map((warningVoid) => {
        const matchingFulfillment = fulfillments.find((fulfillment) => fulfillment.fulfillmentId === warningVoid.fulfillmentId);
        return {
          fulfillment: matchingFulfillment,
          voided: false,
          message: {
            isWarning: true,
            message: warningVoid.message,
          },
        };
      });

    return {
      ...state,
      loading: false,
      successfullyVoided: successfullyVoided.concat(newSuccessfullyVoided),
      voidWarnings: newVoidWarnings,
    };
  },
  [Actions.VOID_LABELS_FAILURE]: (state) => {
    const { fulfillments, successfullyVoided, voidWarnings } = state;
    const message = {
      isWarning: true,
      message: messages.tryAgain,
    };
    if (successfullyVoided.length === 0 && voidWarnings.length === 0) {
      const newVoidWarnings = fulfillments.map((fulfillment) => ({
        ...fulfillment,
        message,
        voided: false,
      }));
      return {
        ...state,
        loading: false,
        voidWarnings: newVoidWarnings,
      };
    }
    return {
      ...state,
      loading: false,
      voidWarnings: voidWarnings.map((warning) => ({
        ...warning,
        voided: false,
        message,
      })),
    };
  },
  [Actions.RETRY_VOID]: (state) => ({ ...state, loading: true }),
  [Actions.LOAD_BULK_VOID_RESPONSE]: (state, { voidWarnings = [], successfullyVoided = [] }) => {
    return {
      ...state,
      voidWarnings,
      successfullyVoided,
      loading: false,
    };
  },
};

export const reduce = (state = initialState, action) => {
  const reducer = actionTypeToReducerMap[action.type];
  if (!reducer) {
    return state;
  }
  return reducer(state, action);
};

export { namespace } from './labels.reducer.metadata';
